module.exports = __webpack_public_path__ + "static/media/pcr-promocode.f8ae8992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcr-promocode.png
// module id = 356
// module chunks = 0